import { RouteComponentProps, WindowLocation } from '@reach/router';
import React, { useContext, useEffect, useState } from 'react';
import { Query } from 'react-apollo';
import { DetailHeader } from '../../../../components/pageElements';
import { ErrorScreen, Loading } from '../../../../components/utils';
import { NotebookContext } from '../../../../context/NotebookContext';
import { subjectBySlugQuery } from '../../../../queries/subjects';
import {
  SubjectBySlugQuery,
  SubjectBySlugQueryVariables
} from '../../../../queries/__generated__/SubjectBySlugQuery';
import SubjectData from './data';
import SubjectFeed from './feed';
import SubjectSettings from './settings';

interface SubjectProps extends RouteComponentProps {
  location: WindowLocation;
  initialActiveTab: 'DATA' | 'FEED' | 'SETTINGS';
  subjectSlug: string;
}

const Subject: React.FC<SubjectProps> = ({ location, subjectSlug, initialActiveTab = 'DATA' }) => {
  const { notebook } = useContext(NotebookContext);
  const [activeTab, setActiveTab] = useState(initialActiveTab);

  useEffect(() => {
    if (location.state && location.state.isEmpty) {
      setActiveTab('SETTINGS');
    }
  }, []);

  return (
    <div
      className="w-100 center pb5 pt5"
      style={{
        maxWidth: 695
      }}
    >
      <Query<SubjectBySlugQuery, SubjectBySlugQueryVariables>
        query={subjectBySlugQuery}
        variables={{ slug: subjectSlug, notebookId: notebook.id }}
      >
        {({ data, loading, error }) => {
          if (loading) {
            return <Loading />;
          }
          if (error) {
            return <ErrorScreen error={error.message} />;
          }
          if (data!.subjectBySlug == null) {
            return <ErrorScreen error={'Expected to find a subject with that slug'} />;
          }

          const subject = data!.subjectBySlug!;

          return (
            <>
              <DetailHeader detail={subject} activeTab={activeTab} setActiveTab={setActiveTab} />

              {activeTab === 'DATA' && (
                <SubjectData subject={subject} setActiveTab={setActiveTab} />
              )}
              {activeTab === 'FEED' && (
                <SubjectFeed subject={subject} setActiveTab={setActiveTab} />
              )}
              {activeTab === 'SETTINGS' && <SubjectSettings subject={subject} />}
            </>
          );
        }}
      </Query>
    </div>
  );
};

export default Subject;
